import { ReactElement, ReactNode } from 'react';

import { RefreshIcon } from '../icons/RefreshIcon';

interface Props {
  children: ReactNode;
  showSearch?: boolean;
  reset: () => void;
}

const DentistSearchContainer = ({
  children,
  showSearch = false,
  reset,
}: Props): ReactElement => (
  <section className="mt-5 bg-neutral-white rounded-xl shadow-card mx-5 px-4 py-2">
    <div className="flex flex-wrap justify-between items-center gap-y-2">
      {/* 
      <div className="flex items-center gap-1">
        <img
          className="w-5 h-5 max-[1300px]:w-4 max-[1300px]:h-4"
          src="/assets/images/icons/search.svg"
          alt="Ícone de busca"
        />
        <h2 className="text-xl max-[800px]:text-base font-semibold text-primary-main">
          Critérios de busca:
        </h2>
      </div>
      */}
      <>
        <button
          className="max-[1300px]:hidden flex items-center gap-1 px-2 py-1"
          onClick={reset}
        >
          <RefreshIcon />
          <span className="text-primary-main text-xs font-semibold uppercase">
            Fazer nova busca
          </span>
        </button>
        <button
          className="min-[1300px]:hidden flex items-center gap-1 px-2 py-1"
          onClick={reset}
        >
          <RefreshIcon />
          <span className="text-xs">Nova busca</span>
        </button>
      </>
    </div>
    {children}
  </section>
);

export default DentistSearchContainer;
